/** Detects URLs we can render as inline embeds on the public card. */

export type EmbedKind = 'youtube' | 'vimeo' | 'spotify';

export interface EmbedInfo {
  kind: EmbedKind;
  src: string;
  aspect: 'video' | 'square' | 'tall';
}

export function detectEmbed(url: string | null | undefined): EmbedInfo | undefined {
  if (!url) return undefined;

  // YouTube
  const yt =
    url.match(/(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/i);
  if (yt) {
    return {
      kind: 'youtube',
      src: `https://www.youtube.com/embed/${yt[1]}?rel=0`,
      aspect: 'video',
    };
  }

  // Vimeo
  const vm = url.match(/vimeo\.com\/(\d+)/i);
  if (vm) {
    return {
      kind: 'vimeo',
      src: `https://player.vimeo.com/video/${vm[1]}`,
      aspect: 'video',
    };
  }

  // Spotify (track, episode, show, playlist, album)
  const sp = url.match(/open\.spotify\.com\/(track|episode|show|playlist|album)\/([a-zA-Z0-9]+)/i);
  if (sp) {
    return {
      kind: 'spotify',
      src: `https://open.spotify.com/embed/${sp[1]}/${sp[2]}`,
      aspect: sp[1] === 'episode' || sp[1] === 'show' ? 'square' : 'square',
    };
  }

  // Instagram is deliberately NOT embedded. Its /embed/ endpoint renders a
  // blank or login-walled box for most posts unless Instagram's embed.js is
  // injected (and often even then). Instagram links fall through to the
  // regular link list, which always works.
  return undefined;
}
